"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSummaryStore = void 0;
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Calculator_1 = require("@CommonFrontendBackend/Quote/Calculator");
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var Types_1 = require("@CommonFrontendBackend/Quote/Types");
var pages_common_1 = require("@qwilr/pages-common");
var mobx_1 = require("mobx");
var QuoteSummaryStore = (function () {
    function QuoteSummaryStore(quoteSummary, accountQuoteSettings, usingFeature, quoteInteractionsStore) {
        var _this = this;
        this.accountQuoteSettings = accountQuoteSettings;
        this.quoteInteractionsStore = quoteInteractionsStore;
        this._quoteSummary = quoteSummary;
        if (usingFeature(FeatureFlag_1.default.QuoteWidgetisation)) {
            (0, mobx_1.reaction)(function () { var _a; return (_a = _this.priceSummary.total["one-off"]) === null || _a === void 0 ? void 0 : _a.billable; }, function (totalBillable) {
                pages_common_1.PubSub.publish("qwilr:quote-total-changed", { total: totalBillable !== null && totalBillable !== void 0 ? totalBillable : 0 });
            });
        }
    }
    Object.defineProperty(QuoteSummaryStore.prototype, "quoteSummary", {
        get: function () {
            var _this = this;
            return {
                blocks: this._quoteSummary.blocks.map(function (b) { return (__assign(__assign({}, b), { sections: b.sections.map(function (s) { return (__assign(__assign({}, s), { selection: __assign({}, getMergedSelectionState(s, _this.quoteInteractionsStore.getQuoteInteractionById(s.id))), lineItems: s.lineItems.map(function (l) { return (__assign(__assign({}, l), { selection: __assign({}, getMergedSelectionState(l, _this.quoteInteractionsStore.getQuoteInteractionById(l.id))) })); }) })); }) })); }),
                priceContext: this._quoteSummary.priceContext,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSummaryStore.prototype, "priceSummary", {
        get: function () {
            return (0, Calculator_1.calculatePriceSummary)(this.quoteSummary, {
                currency: "AUD",
                taxes: this.accountQuoteSettings.taxes.map(function (tax) { return ({
                    id: tax.id,
                    name: tax.name,
                    rate: tax.percent,
                }); }),
                discounts: this.accountQuoteSettings.discounts.map(function (discount) { return ({
                    id: discount.id,
                    name: discount.name,
                    amount: discount.amount,
                    amountType: { percent: "percentage", fixed: "flat" }[discount.type],
                }); }),
            });
        },
        enumerable: false,
        configurable: true
    });
    QuoteSummaryStore.prototype.toggleLineItemSelected = function (id) {
        var e_1, _a, e_2, _b, e_3, _c;
        var itemQuoteSummary = (0, Helpers_1.getQuoteSummaryForItem)(this.quoteSummary, "lineItem", id);
        if (itemQuoteSummary.selection.mode === "optional") {
            var willBeSelected = !itemQuoteSummary.selection.selected;
            this.quoteInteractionsStore.createOrUpdateQuoteInteraction(id, "lineItem", { selected: willBeSelected }, (0, Helpers_1.getQuoteSummaryForItem)(this._quoteSummary, "lineItem", id));
            if (itemQuoteSummary.selection.singleSelect && willBeSelected) {
                try {
                    for (var _d = __values(this.quoteSummary.blocks), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var block = _e.value;
                        try {
                            for (var _f = (e_2 = void 0, __values(block.sections)), _g = _f.next(); !_g.done; _g = _f.next()) {
                                var section = _g.value;
                                if (section.lineItems.find(function (f) { return f.id === itemQuoteSummary.id; })) {
                                    try {
                                        for (var _h = (e_3 = void 0, __values(section.lineItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                            var lineItem = _j.value;
                                            if (lineItem.id !== itemQuoteSummary.id &&
                                                lineItem.selection.mode === "optional" &&
                                                lineItem.selection.singleSelect &&
                                                lineItem.selection.selected) {
                                                this.quoteInteractionsStore.createOrUpdateQuoteInteraction(lineItem.id, "lineItem", { selected: false, price: 1 }, (0, Helpers_1.getQuoteSummaryForItem)(this._quoteSummary, "lineItem", lineItem.id));
                                            }
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
    };
    QuoteSummaryStore.prototype.toggleSectionSelected = function (id) {
        var e_4, _a, e_5, _b;
        var sectionQuoteSummary = (0, Helpers_1.getQuoteSummaryForItem)(this.quoteSummary, "section", id);
        if (sectionQuoteSummary.selection.mode === "optional") {
            var willBeSelected = !sectionQuoteSummary.selection.selected;
            this.quoteInteractionsStore.createOrUpdateQuoteInteraction(id, "section", { selected: willBeSelected }, (0, Helpers_1.getQuoteSummaryForItem)(this._quoteSummary, "section", id));
            if (sectionQuoteSummary.selection.singleSelect && willBeSelected) {
                try {
                    for (var _c = __values(this.quoteSummary.blocks), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var block = _d.value;
                        if (block.sections.find(function (f) { return f.id === sectionQuoteSummary.id; })) {
                            try {
                                for (var _e = (e_5 = void 0, __values(block.sections)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                    var section = _f.value;
                                    if (section.id !== sectionQuoteSummary.id &&
                                        section.selection.mode === "optional" &&
                                        section.selection.singleSelect &&
                                        section.selection.selected) {
                                        this.quoteInteractionsStore.createOrUpdateQuoteInteraction(section.id, "section", { selected: false }, (0, Helpers_1.getQuoteSummaryForItem)(this._quoteSummary, "section", section.id));
                                    }
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
    };
    var _a, _b;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof Types_1.QuoteSummary !== "undefined" && Types_1.QuoteSummary) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], QuoteSummaryStore.prototype, "quoteSummary", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof Types_1.PriceSummary !== "undefined" && Types_1.PriceSummary) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], QuoteSummaryStore.prototype, "priceSummary", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], QuoteSummaryStore.prototype, "toggleLineItemSelected", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], QuoteSummaryStore.prototype, "toggleSectionSelected", null);
    return QuoteSummaryStore;
}());
exports.QuoteSummaryStore = QuoteSummaryStore;
var getMergedSelectionState = function (itemOrSection, interactionEntry) {
    if (itemOrSection.selection.mode === "optional") {
        if (!interactionEntry || interactionEntry.selected == undefined) {
            return itemOrSection.selection;
        }
        return __assign(__assign({}, itemOrSection.selection), { selected: interactionEntry.selected });
    }
    return itemOrSection.selection;
};
